import { useState } from 'react';
import ImageViewer from './ImageViewer';

const PREVIEW_LIMIT = 30;

function formatBytes(bytes) {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(0)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

function formatTimestamp(seconds) {
  if (seconds == null || !isFinite(seconds) || seconds < 0) return '-';
  const total = Math.floor(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  return `${m}:${String(s).padStart(2, '0')}`;
}

function ImageGrid({ frames, scores = {} }) {
  const [showAll, setShowAll] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);

  if (!frames || frames.length === 0) return null;

  const visible =
    showAll || frames.length <= PREVIEW_LIMIT
      ? frames
      : frames.slice(0, PREVIEW_LIMIT);
  const hidden = frames.length - visible.length;

  return (
    <>
      <div className="ws-frames-grid">
        {visible.map((frame, index) => {
          const score = scores[frame.frameNumber]?.sharpness;
          return (
            <button
              key={frame.frameNumber}
              type="button"
              className="ws-frame-cell"
              onClick={() => setSelectedIndex(index)}
              aria-label={`Frame ${frame.frameNumber} at ${formatTimestamp(frame.timestamp)}`}
            >
              <img src={frame.thumbnailUrl} alt="" loading="lazy" />
              <span className="ws-frame-ts">{formatTimestamp(frame.timestamp)}</span>
              <span className="ws-frame-idx">
                #{String(frame.frameNumber).padStart(3, '0')}
              </span>
              {frame.width && (
                <span className="ws-frame-spec">
                  {frame.width}×{frame.height}
                  {frame.size != null ? ` · ${formatBytes(frame.size)}` : ''}
                </span>
              )}
              {typeof score === 'number' && (
                <span className="ws-frame-score" title="Sharpness (Laplacian variance)">
                  ◑ {Math.round(score)}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {hidden > 0 && (
        <div className="ws-frames-showall">
          <button type="button" className="btn-link" onClick={() => setShowAll(true)}>
            Show all {frames.length} frames
          </button>
        </div>
      )}

      {selectedIndex !== null && (
        <ImageViewer
          frames={frames}
          selectedIndex={selectedIndex}
          onSelect={setSelectedIndex}
          onClose={() => setSelectedIndex(null)}
        />
      )}
    </>
  );
}

export default ImageGrid;
